<template lang="pug">
div
  v-btn(block color="primary" text @click="tab=0").d-flex.align-center
    v-icon mdi-arrow-left
    span.ml-1 Back
    v-spacer
  v-card.pa-4(flat)
    v-card-title {{slotString}}
    v-expansion-panels(v-model="expandedFacility" mandatory)
      v-expansion-panel(v-for='facility in slotBreakdown' :key="facility.id").mt-2
        v-expansion-panel-header(:color='headerColor(facility)')
          strong {{facility.facility_name}}
        v-expansion-panel-content
          div(v-for='space in facility.athletic_space' :key="space.id" v-if="space.slots.length").mt-2.d-flex.align-center.justify-space-between
            div
              span.body-1 {{space.name}}
                span.caption.ml-1(v-if="space.door") (Door: {{space.door}})
              span.body-2.text--secondary.ml-2 {{space.description}}
            v-tooltip(right v-if="season.sport=='BASKETBALL'")
              template(v-slot:activator="{ on, attrs }")
                v-icon.ml-2(v-bind="attrs" v-on="on" color="primary" @click="showSpaceDetails(space)" aria-label="View basket details") mdi-help-circle-outline
              span View Basket Details
            v-divider.mx-4(style="opacity:0.5")
            .d-flex.flex-wrap
              div.ma-1(v-for="slot in space.slots" :key="slot.id")
                v-btn(
                  v-if="!isInTimingWindow"
                  disabled
                ) {{slot.name}} (Outside Registration Window)
                v-promise-btn.white--text(
                  v-else-if="slot.status.reserved"
                  color="#2E7D32"
                  @click="releaseSession(space.session.id)"
                  skipSuccess
                  confirm
                ) {{slot.name}} (Reserved)
                  template(v-slot:confirmation) Remove reserved session?
                v-promise-btn.white--text(
                  v-else-if="slot.status.pending"
                  color='#CE93D8'
                  @click="removePendingSession(space.session.id)"
                  skipSuccess
                  confirm
                ) {{slot.name}} (Pending)
                  template(v-slot:confirmation) Remove pending session?
                v-btn(
                  v-else-if="slot.status.full"
                  color='primary'
                  disabled
                ) {{slot.name}} (Full)
                v-btn(
                  v-else-if="!slot.status.available"
                  color="secondary"
                  disabled
                ) {{slot.name}} (Unavailable)
                v-btn(
                  v-else-if="!reservationsAllowedOnCurrentSlot || space.status.pending || space.status.reserved"
                  color="#BBDEFB"
                  disabled
                ) Reservation Allowance Exhausted
                v-promise-btn(
                  v-else
                  color='primary'
                  @click="reserveSession({id:space.session.id,facility,space,slotString,valid:true,team: {...team},breakout:slot.breakout,breakoutName:slot.name})"
                  skipSuccess
                ) Reserve {{slot.name}}
          div(v-else)
            div.body-1.my-4 This facility has no sessions for this time slot.
  v-dialog(v-model="dialog" max-width=800)
    v-card(v-if="selectedSpace").pb-1
      v-card-title
        strong {{selectedSpace.name}} - Basket Details
      v-card.ma-4.mt-8(
        v-for="basket in selectedSpace.gym_basket_detail"
        :key="selectedSpace.id"
        outlined
      )
        v-card-title(style="margin-top:-30px")
          span.px-1(style="background-color:white") {{basket.basket_type}}
        v-card-text
          v-row
            v-col(cols=6).py-0
              strong.mr-2 Basket Height:
              span {{basket.basket_height}}
            v-col(cols=6).py-0
              strong.mr-2 Adjustable:
              span {{basket.adjustable ? "Yes" : "No"}}
            v-col(cols=6).py-0
              strong.mr-2 Setup:
              span {{basket.setup}}
            v-col(cols=6).py-0
              strong.mr-2 Crank Location:
              span {{basket.location_crank}}
            v-col(cols=12).py-0
              strong.mr-2 Comments:
              span {{basket.comments}}
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import VPromiseBtn from '@/components/VPromiseBtn'

export default {
  components: {
    VPromiseBtn
  },
  data: () => ({
    expandedFacility: 0,
    dialog: false
  }),
  computed: {
    ...mapGetters([
      'isInTimingWindow',
      'reservationsAllowedOnCurrentSlot',
      'season',
      'slotBreakdown',
      'slotString',
      'team',
      'registrationGroup'
    ]),
    ...mapState([
      'pendingSessions',
      'selectedFacilities',
      'selectedSlot'
    ]),
    selectedSpace: {
      get () {
        return this.$store.state.main.space
      },
      set (value) {
        this.$store.commit('setSpace', value)
      }
    },
    tab: {
      get () {
        return this.$store.state.main.tab
      },
      set (value) {
        this.$store.commit('setTab', value)
        this.$store.dispatch('lazyRefresh')
      }
    }
  },
  watch: {
    slotBreakdown(val) {
      let index = val.findIndex(facility => facility.spaces_available || facility.pending || facility.reserved)
      this.expandedFacility = index && index > 0 ? index : 0
    },
    expandedFacility() {
      this.$store.dispatch('lazyRefresh')
    }
  },
  mounted() {
    let index = this.slotBreakdown.findIndex(facility => facility.spaces_available || facility.pending || facility.reserved)
      this.expandedFacility = index && index > 0 ? index : 0
  },
  methods: {
    headerColor(facility) {
      if(facility.reserved)
        return '#A5D6A7'
      else if(facility.pending)
        return '#E1BEE7'
      else if(facility.spaces_available)
        return '#BBDEFB'
      else
        return '#DDD'
    },
    showSpaceDetails (space) {
      this.selectedSpace = space
      this.dialog = true
    },
    async releaseSession(sessionId) {
      await this.$store.dispatch('releaseSession', sessionId)
    },
    async removePendingSession(sessionId) {
      this.$store.commit('removePendingSession', sessionId)
      await this.$store.dispatch('refresh')
    },
    async reserveSession(data) {
      this.$store.commit('addPendingSession', data)
      await this.$store.dispatch('refresh')
    }
  }
}
</script>